import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var ApplyValueTransformers = /*#__PURE__*/function () {
  function ApplyValueTransformers() {
    _classCallCheck(this, ApplyValueTransformers);
  }
  _createClass(ApplyValueTransformers, null, [{
    key: "transformFrom",
    value: function transformFrom(transformer, databaseValue) {
      if (Array.isArray(transformer)) {
        var reverseTransformers = transformer.slice().reverse();
        return reverseTransformers.reduce(function (transformedValue, _transformer) {
          return _transformer.from(transformedValue);
        }, databaseValue);
      }
      return transformer.from(databaseValue);
    }
  }, {
    key: "transformTo",
    value: function transformTo(transformer, entityValue) {
      if (Array.isArray(transformer)) {
        return transformer.reduce(function (transformedValue, _transformer) {
          return _transformer.to(transformedValue);
        }, entityValue);
      }
      return transformer.to(entityValue);
    }
  }]);
  return ApplyValueTransformers;
}();